export default __webpack_public_path__ + "static/media/bCFX.01e96424.png";